import { useIntl } from 'react-intl';
import type { ActivityType } from '@alltrails/types/ActivityType';
import getActivityType from '../utils/getActivityType';

const activityTypes: ActivityType[] = [
  'backpacking',
  'birding',
  'bike-touring',
  'camping',
  'cross-country-skiing',
  'fishing',
  'hiking',
  'horseback-riding',
  'mountain-biking',
  'off-road-driving',
  'paddle-sports',
  'road-biking',
  'rock-climbing',
  'running',
  'scenic-driving',
  'snowshoeing',
  'skiing',
  'trail-running',
  'via-ferrata',
  'walking'
];

export default function useActivityStrings() {
  const intl = useIntl();

  const activities: { value: ActivityType; label: string }[] = activityTypes.map((value: ActivityType) => ({
    value,
    label: getActivityType(intl, value)
  }));

  return {
    activitySelectOptions: activities,
    findByValue(id = 'hiking') {
      // defaults to hiking if no id is passed or if the id passed is null, which the default parameter functionality doesn't cover
      const activityId = id || 'hiking';
      return activities.find(activity => activity.value === activityId);
    }
  };
}
